import React, { useState, useEffect } from "react";

import "../../assets/css/candidate-tracking.css";
import questionmark from "../../assets/img/ico/questionmark.svg";

const CandidateTrackingDashboard = () => {
  const [sortBy, setSortBy] = useState("recent");
  const [selectedMission, setSelectedMission] = useState(null);
  const [missions, setMissions] = useState([]);
  const [applicantsData, setApplicantsData] = useState({});

  const fetchMissions = async () => {
    // TODO: Remplacer par appel API backend
    // Simule un fetch
    setMissions([
      {
        id: 1,
        title: "2 Cuisiniers H/F",
        location: "Rouen (76)",
        rate: "11,00 € / heure",
        createdAt: "01/01/2024", 
        applicantsCount: 3,
        startTime: "8h00",
        startDate: "16 mars 2025",
        endTime: "16h00",
        endDate: "25 mars 2025",
      },
      {
        id: 2,
        title: "1 Serveur H/F",
        location: "Le Havre (76)",
        rate: "10,50 € / heure",
        createdAt: "15/12/2024",
        applicantsCount: 5,
        startTime: "10h00",
        startDate: "16 mars 2025",
        endTime: "15h00",
        endDate: "26 mars 2025",
      },
      {
        id: 3,
        title: "1 Plongeur H/F",
        location: "Dieppe (76)",
        rate: "10,80 € / heure",
        createdAt: "20/11/2024",
        applicantsCount: 2,
        startTime: "9h00",
        startDate: "20 mars 2025",
        endTime: "17h00",
        endDate: "22 mars 2025",
      },
      {
        id: 4,
        title: "1 Chef de rang H/F",
        location: "Évreux (27)",
        rate: "12,00 € / heure",
        createdAt: "05/01/2025",
        applicantsCount: 4,
        startTime: "18h00",
        startDate: "18 mars 2025",
        endTime: "23h00",
        endDate: "18 mars 2025",
      },
    ]);
  };

  const fetchApplicants = async (missionId) => {
    // TODO: Remplacer par appel API backend
    // Simule un fetch
    const mockApplicants = {
      1: [
        { id: 1, name: "Lucas Prochon", cvUrl: "#" },
        { id: 2, name: "Lucas Prochon", cvUrl: "#" },
        { id: 3, name: "Lucas Prochon", cvUrl: "#" },
      ],
      2: [
        { id: 1, name: "Lucas Prochon", cvUrl: "#" },
        { id: 2, name: "Emma Dupont", cvUrl: "#" },
        { id: 3, name: "Julien Martin", cvUrl: "#" },
        { id: 4, name: "Sophie Bernard", cvUrl: "#" },
        { id: 5, name: "Clara Lefevre", cvUrl: "#" },
      ],
      3: [
        { id: 1, name: "Lucas Prochon", cvUrl: "#" },
        { id: 2, name: "Alice Moreau", cvUrl: "#" },
      ],
      4: [
        { id: 1, name: "Lucas Prochon", cvUrl: "#" },
        { id: 2, name: "Chloé Girard", cvUrl: "#" },
        { id: 3, name: "Antoine Petit", cvUrl: "#" },
        { id: 4, name: "Thomas Dubois", cvUrl: "#" },
      ],
    };
    setApplicantsData((prev) => ({ ...prev, [missionId]: mockApplicants[missionId] || [] }));
  };

  useEffect(() => {
    fetchMissions();
  }, []);

  // === HANDLERS ===
  const handleSortChange = (event) => {
    setSortBy(event.target.value);
    // TODO: Appeler le backend pour trier les missions si besoin
    console.log("Tri par:", event.target.value);
  };

  const handleCreateMission = () => {
    // TODO: Ouvrir un modal ou rediriger vers la création de mission (backend)
    console.log("Redirection ou ouverture modal pour créer une mission");
  };

  const handleModifyMission = (missionId) => {
    // TODO: Ouvrir un modal ou une page d'édition (backend)
    console.log("Modifier la mission:", missionId);
  };

  const handleDeleteMission = (missionId) => {
    // TODO: Appeler le backend pour supprimer la mission
    console.log("Supprimer la mission:", missionId);
    alert(`Supprimer la mission ${missionId} ? (Logique à implémenter)`);
  };

  const handleAcceptApplicant = (missionId, applicantId) => {
    // TODO: Appeler le backend pour accepter le candidat
    console.log("Accepter le candidat", applicantId, "pour la mission", missionId);
  };

  const handleRefuseApplicant = (missionId, applicantId) => {
    // TODO: Appeler le backend pour refuser le candidat
    console.log("Refuser le candidat", applicantId, "pour la mission", missionId);
  };

  const handleViewApplicants = (missionId) => {
    setSelectedMission(missionId);
    fetchApplicants(missionId);
  };

  const handleCloseApplicantsPanel = () => {
    setSelectedMission(null);
  };

  return (
    <div className="ctd-dashboard-grid-layout">
      <div className="ctd-dashboard-actions-bar">
        <h2>Missions créer & suivi des candidatures</h2>
        <div className="ctd-dashboard-actions">
          <button
            className="btn fill green ctd-create-mission-btn"
            onClick={handleCreateMission}
          >
            Créer une nouvelle mission
          </button>
          <div className="ctd-sort-container">
            <label htmlFor="sort-missions">Trier par</label>
            <select
              id="sort-missions"
              value={sortBy}
              onChange={handleSortChange}
              className="ctd-mission-select"
            >
              <option value="recent">Plus récent</option>
              <option value="old">Plus ancien</option>
              <option value="deleted">Supprimé</option>
              <option value="expired">Expiré</option>
              <option value="all">Tout voir</option>
            </select>
          </div>
        </div>
      </div>
      <div className="ctd-mission-grid-list">
        {missions.map((mission) => (
          <React.Fragment key={mission.id}>
            <div className={`ctd-mission-card${selectedMission === mission.id ? ' ctd-selected' : ''}`}> 
              <div className="ctd-mission-card-info">
                <h3>{mission.title}</h3>
                <div className="ctd-mission-card-meta">
                  <p className="ctd-location">{mission.location}</p>
                  <p className="ctd-rate">{mission.rate}</p>
                  <p className="ctd-created-at">Créé le : {mission.createdAt}</p>
                </div>
              </div>
              <div className="ctd-mission-card-details">
                <div className="ctd-applicant-info">
                  <a className="ctd-applicant-link" onClick={(e) => { e.preventDefault(); handleViewApplicants(mission.id); }}>
                    {mission.applicantsCount} candidat{mission.applicantsCount > 1 ? 's ont' : ' a'} postulé{mission.applicantsCount > 1 ? 's' : ''}
                  </a>
                  <span className="ctd-applicant-icons">
                    {[...Array(Math.min(3, mission.applicantsCount))].map((_, idx) => (
                      <img
                        key={idx}
                        src={questionmark}
                        alt="?"
                        className="ctd-questionmark-icon"
                        style={{ zIndex: 3 - idx, marginLeft: idx === 0 ? 0 : -16 }}
                      />
                    ))}
                  </span>
                </div>
                <div className="ctd-mission-time">
                  <div className="ctd-mission-time-block">
                    <span className="ctd-mission-hour">{mission.startTime}</span>
                    <span className="ctd-mission-date">{mission.startDate}</span>
                  </div>
                  <span className="ctd-mission-arrow">&gt;</span>
                  <div className="ctd-mission-time-block">
                    <span className="ctd-mission-hour">{mission.endTime}</span>
                    <span className="ctd-mission-date">{mission.endDate}</span>
                  </div>
                </div>
              </div>
              <div className="ctd-mission-card-actions">
                <button className="btn fill green" onClick={() => handleDeleteMission(mission.id)}>Supprimer la mission</button>
                <button className="btn outline green" onClick={() => handleModifyMission(mission.id)}>Modifier la mission</button>
              </div>
            </div>
            {selectedMission === mission.id ? (
              <div className="ctd-applicants-panel-inline">
                <button
                  className="ctd-close-inline-panel-btn"
                  onClick={handleCloseApplicantsPanel}
                  aria-label="Fermer le panneau des candidats"
                >
                  &times;
                </button>
                {(applicantsData[selectedMission] || []).map((applicant) => (
                  <div key={applicant.id} className="ctd-applicant-card">
                    <div className="ctd-applicant-avatar">
                      <img src={questionmark} alt="?" />
                    </div>
                    <div className="ctd-applicant-info-block">
                      <span className="ctd-applicant-name">{applicant.name}</span>
                      <a
                        href={applicant.cvUrl}
                        className="ctd-applicant-download"
                        download
                      >
                        Télécharger le CV
                      </a>
                    </div>
                    <div className="ctd-applicant-actions">
                      <button
                        className="btn fill green"
                        onClick={() =>
                          handleAcceptApplicant(selectedMission, applicant.id)
                        }
                      >
                        Accepter
                      </button>
                      <button
                        className="btn outline red"
                        onClick={() =>
                          handleRefuseApplicant(selectedMission, applicant.id)
                        }
                      >
                        Refuser
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div />
            )}
          </React.Fragment>
        ))}
        {missions.length === 0 && (
          <p>Aucune mission à afficher pour le moment.</p>
        )}
      </div>
    </div>
  );
};

export default CandidateTrackingDashboard;